var notification = require('notification'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    authenticationService = require('authenticationService');

var userResetPassword = (function () {
    var formValidation = function () {
        $('#reset-password-form').validate({
            onfocusout: false,
            onkeyup: false,
            onclick: false,
            onsubmit: true,
            highlight: function (element) {
                $('.login .panel.left-panel').addClass('has-error');
            },
            rules: {
                email_address: {
                    required: true,
                    email: true
                }
            },
            submitHandler: function () {
                $('.login .panel.left-panel').removeClass('has-error').addClass('passed');
                $('window').showLoader();
                new checkUserDetails();
            }
        });
    };

    var checkUserDetails = function () {
        var item = new Object();
        item.emailAddress = $('#email-address').val();
        var data = JSON.stringify(item);
        resetPasswordService(data, resetPasswordResponse, resetPasswordErrorResponse);
    };

    var resetPasswordResponse = function (response) {
        if (response.status === 'success') {
            $('.left-panel').removeClass('has-error');
            $('window').notification({
                title: response.message,
                important: true
            });
            // setTimeout(function () {
            //     window.location.href = "/login";
            // }, 2000);

        } else {
            $('.left-panel').addClass('has-error');
            $('window').notification({
                title: response.message,
                error: true
            });
        }

    };

    var resetPasswordErrorResponse = function () {
        $('window').notification({
            title: 'Unable to communicate with the server at this time. Please try again or <a href="mailto:help@thecoachingmanual.com?subject=Cannot reset my password">contact us if the problem persists</a>.',
            error: true
        });

    };
    var init = function () {
        formValidation();
    };
    return {
        init: init
    };
})();

if ($('#reset-password-form').length) {
    userResetPassword.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/login/reset-password.js